var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5308 10.9753C30.3752 10.4002 30.0717 9.87594 29.6504 9.45466C29.2291 9.03339 28.7049 8.72982 28.1298 8.57418C26.0245 8 17.5512 8 17.5512 8C17.5512 8 9.07757 8.01738 6.97224 8.59156C6.39716 8.74721 5.87288 9.0508 5.45163 9.47209C5.03037 9.89338 4.72683 10.4177 4.57123 10.9928C3.93442 14.7335 3.68739 20.4336 4.58872 24.0247C4.74433 24.5998 5.04788 25.1241 5.46914 25.5453C5.89039 25.9666 6.41466 26.2702 6.98972 26.4258C9.09505 27 17.5685 27 17.5685 27C17.5685 27 26.0419 27 28.1471 26.4258C28.7222 26.2702 29.2465 25.9666 29.6677 25.5454C30.089 25.1241 30.3926 24.5998 30.5482 24.0247C31.2199 20.2787 31.4268 14.5822 30.5308 10.9754V10.9753Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8545 21.5715L21.8838 17.5001L14.8546 13.4287L14.8545 21.5715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a585e72e195bc01158350f723328926b.svg";
export { ForwardRef as ReactComponent };